// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_54-0";
export var eligibilityCardNotEligible = "_54-1";